import { gsap } from 'gsap'
// Free Plugins
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { PixiPlugin } from 'gsap/PixiPlugin'
import { Flip } from 'gsap/Flip'
import { Observer } from 'gsap/Observer'
import { Draggable } from 'gsap/Draggable'
import { EaselPlugin } from 'gsap/EaselPlugin'
import { TextPlugin } from 'gsap/TextPlugin'
// Free Eases
import { RoughEase, SlowMo, ExpoScaleEase } from 'gsap/EasePack'
import { CustomEase } from 'gsap/all'

export default defineNuxtPlugin(() => {
  gsap.registerPlugin(
    ScrollTrigger,
    ScrollToPlugin,
    MotionPathPlugin,
    PixiPlugin,
    Flip,
    Observer,
    Draggable,
    EaselPlugin,
    TextPlugin,
    RoughEase,
    SlowMo,
    ExpoScaleEase,
    CustomEase,
  )

  return {
    provide: { gsap },
  }
})
